import { render, staticRenderFns } from "./Glosario.vue?vue&type=template&id=6e5405be"
import script from "./Glosario.vue?vue&type=script&lang=js"
export * from "./Glosario.vue?vue&type=script&lang=js"
import style0 from "./Glosario.vue?vue&type=style&index=0&id=6e5405be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports